import {NgModule} from '@angular/core';
import {ExtendedModule, FlexLayoutModule} from '@angular/flex-layout';
import {MaterialModule} from '../material.module';
import {RouterModule} from '@angular/router';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AutocompleteComponent} from './components/auto-complete/auto-complete.component';
import {UserSelectionComponent} from './components/dialog/user-selection/user-selection.component';
import {BaseComponent} from './components/base/base.component';
import {TimelineComponent} from './components/charts/timeline/timeline.component';
import {BuyerSegmentationComponent} from './components/charts/buyer-segmentation/buyer-segmentation.component';
import {AgentSalesComponent} from './components/charts/agent-sales/agent-sales.component';
import {PropertyTypeComponent} from './components/charts/property-type/property-type.component';
import {YearTrendComponent} from './components/charts/year-trend/year-trend.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {NgxEchartsModule} from 'ngx-echarts';
import {PieChartComponent} from './components/charts/pie-chart/pie-chart.component';
import {SalesTargetComponent} from './components/charts/sales-target/sales-target.component';
import {SurroundingPropertyComponent} from './components/charts/surrounding-property/surrounding-property.component';
import {AveragePropertyComponent} from './components/charts/average-property/average-property.component';
import {ViewsComponent} from './components/charts/views/views.component';
import {CommissionInputGroupComponent} from './components/commission-input-group/commission-input-group.component';
import {NgxCurrencyModule} from 'ngx-currency';
import {ReadMoreComponent} from './components/read-more/read-more.component';
import {MatRangeSliderComponent} from './components/range-slider/range-slider.component';
import {CustomDropzonePreviewComponent} from './components/custom-dropzone-preview/custom-dropzone-preview.component';
import {NgxDropzoneModule} from 'ngx-dropzone';
import {ImagePreviewComponent} from './components/dialog/image-preview/image-preview.component';
import {SwiperModule} from 'swiper/angular';
import {LoadingComponent} from './components/loading/loading.component';
import {ConfirmComponent} from './components/dialog/confirm/confirm.component';
import {NewFooterComponent} from './components/new-footer/new-footer.component';
import '@google/model-viewer';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {WelcomeDialogComponent} from './components/dialog/welcome-dialog/welcome-dialog.component';
import {MatIconModule} from '@angular/material/icon';
import {EmailVerificationComponent} from './components/dialog/email-verification/email-verification.component';
import {EmailComponent} from './components/email/email.component';

/**
 * @class SharedModule
 * @description This is a module which includes all the reusable, shared component of the system
 */
const COMPONENTS = [
  BreadcrumbComponent,
  AutocompleteComponent,
  UserSelectionComponent,
  BaseComponent,
  TimelineComponent,
  BuyerSegmentationComponent,
  AgentSalesComponent,
  PropertyTypeComponent,
  YearTrendComponent,
  CommissionInputGroupComponent,
  ReadMoreComponent,
  MatRangeSliderComponent,
  CustomDropzonePreviewComponent,
  ImagePreviewComponent,
  LoadingComponent,
  ConfirmComponent,
  NewFooterComponent
];

const THIRD_MODULES = [
  FlexLayoutModule,
  MaterialModule,
];


@NgModule({
  declarations: [...COMPONENTS, PieChartComponent, SalesTargetComponent, SurroundingPropertyComponent,
    AveragePropertyComponent, ViewsComponent, WelcomeDialogComponent, EmailVerificationComponent, EmailComponent],
  imports: [
    RouterModule,
    FormsModule,
    ...THIRD_MODULES,
    NgSelectModule,
    NgxEchartsModule,
    ReactiveFormsModule,
    NgxCurrencyModule,
    NgxDropzoneModule,
    SwiperModule,
    FontAwesomeModule,
    MatIconModule,
    CommonModule,
    ExtendedModule],
  entryComponents: [
    UserSelectionComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ...COMPONENTS,
    RouterModule,
    ...THIRD_MODULES,
    PieChartComponent,
    SalesTargetComponent,
    SurroundingPropertyComponent,
    AveragePropertyComponent,
    ViewsComponent

  ],
  providers: [
    DatePipe,
    // MapsAPILoader

  ]
})

export class SharedModule {
}

